<div class="editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config 
      [width]="class['content-preview-slider']['width']"
      [height]="class['content-preview-slider']['height']"
      [device]="device" [elementChoosing]="objectChoosing"
      (changeWidthHeight)="changeWidthHeight($event)">
    </app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Chỉnh sửa nội dung -->
      <li nz-submenu nzTitle="{{'chinh_sua_noi_dung' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <button class="mt-3" nz-button nzType="primary" (click)="openModalEdit()">
          {{ 'chinh_sua_noi_dung' | translate }}
        </button>
      </li>

      <!-- Cấu hình khoảng đệm-->
      <li nz-submenu nzTitle="{{'vien' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['content-preview-slider']">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[0])">
            {{'bo_goc' | translate}} &#8594;
          </p>
        </div>
      </li>

      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle=" {{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>

        </div>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['content-preview-slider']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>